import React from "react";

import * as R from "ramda";

import { Table, Typography } from "clearsense-ui/components";
import expandAffirmationCode from "utils/expandAffirmationCode";

import Address from "./Address";

import {
  MAILING_ADDRESS_KEYS,
  PRIMARY_PRACTICE_ADDRESS_KEYS,
  SECONDARY_PRACTICE_ADDRESS_KEYS,
} from "../../constants";

const BasicInformation = ({ npiRecord }) => {
  const rowData = [
    ...(npiRecord.entity_type_code === 1
      ? [
          {
            key: "Individual Name",
            value:
              `${npiRecord.provider_name_prefix_text} ${npiRecord.provider_first_name} ${npiRecord.provider_middle_name} ${npiRecord.provider_last_name} ${npiRecord.provider_credential_text}`.replace(
                /\s+/g,
                " "
              ),
          },
        ]
      : [
          {
            key: "Organization Name",
            value: npiRecord.provider_organization_name,
          },
          {
            key: "Organization Subpart",
            value: expandAffirmationCode(npiRecord.is_organization_subpart),
          },
        ]),
    {
      key: "NPI",
      value: npiRecord.npi,
    },
    {
      key: "Enumeration Date",
      value: npiRecord.provider_enumeration_date,
    },
    {
      key: "Certification Date",
      value: npiRecord.certification_date,
    },
    {
      key: "Last Updated",
      value: npiRecord.last_update_date,
    },
    {
      key: "NPI Type",
      value: `${npiRecord.entity_type_code} - ${
        npiRecord.entity_type_code === 1 ? "Individual" : "Organization"
      }`,
    },
    ...(npiRecord.entity_type_code === 1
      ? [
          {
            key: "Sole Proprietor",
            value: expandAffirmationCode(npiRecord.is_sole_proprietor),
          },
        ]
      : []),
    {
      key: "Gender",
      value: `${npiRecord.provider_gender_code === "M" ? "Male" : "Female"}`,
    },
    {
      key: "Status",
      value: "Active",
    },
    ...(npiRecord.entity_type_code === 2
      ? [
          {
            key: "Authorized Official Information",
            value: `Name: ${npiRecord.authorized_official_first_name} ${npiRecord.authorized_official_last_name}\nTitle: ${npiRecord.authorized_official_title_or_position}\nPhone: ${npiRecord.authorized_official_telephone_number}`,
          },
        ]
      : []),
    {
      key: "Mailing Address",
      value: <Address values={R.props(MAILING_ADDRESS_KEYS, npiRecord)} />,
    },
    {
      key: "Primary Practice Address",
      value: (
        <Address values={R.props(PRIMARY_PRACTICE_ADDRESS_KEYS, npiRecord)} />
      ),
    },
    ...(npiRecord.entity_type_code === 1
      ? [
          {
            key: "Secondary Practice Address",
            value: R.intersperse(
              "\n\n",
              npiRecord.practice_locations?.map((pl, idx) => (
                <Address
                  key={idx}
                  values={R.props(SECONDARY_PRACTICE_ADDRESS_KEYS, pl)}
                />
              ))
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <Typography style="h3" className="mt-4">
        Basic Information
      </Typography>
      <Table
        fixedHeight
        columnData={[
          {
            dataIndex: "key",
            title: "Name",
          },
          {
            dataIndex: "value",
            title: "Value",
          },
        ]}
        rowData={rowData}
        className="h-full whitespace-pre"
      />
    </>
  );
};

export default BasicInformation;
